"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_ACTIVE_INTERNAL_DISCOUNT = exports.GET_SITEWIDE_SALE = void 0;
exports.getPromotionServiceData = getPromotionServiceData;
exports.getActiveDiscountData = getActiveDiscountData;
/* eslint-disable */
/* TODO: fix ALL linting errors as some may call out code smells */
const get_1 = __importDefault(require("lodash/get"));
exports.GET_SITEWIDE_SALE = `
    query GeSitewideSale($promoPriorities: [promoPriority]) {
        getSitewideSale(promoPriorities: $promoPriorities) {
            enabled
            kind
            isDevSale
            devSaleParam
            isSitewide
            isPlaceholder
            couponCode
            sitewideName
            keys
            level
            labels
            theme
            fixedAmounts
            percentAmounts
            bmsmAmounts
            additionalFixedDiscount {
                discountAmount
                minThreshold
                label
            }
            bmsmMattress
            percentMattress
            enableBundleDiscounts
            bundleDiscountPercent
            shortPromotionName
            discountConditions {
                aggregator
                options {
                    conditionType
                    isSimple
                    value
                }
            }
            messaging {
                slot
                slotCondition
                messageDesktop
                action
                actionText
            }
            bmsmPanelMessaging {
                title
                subtitle
                underTermsLine1
                underTermsLine2
                ctaLink {
                    url
                    target
                }
                ctaText
                disclaimer
            }
            valuePropsPanelMessaging {
                title
                subtitle
                ctaLink {
                    url
                    target
                }
                ctaText
                disclaimer
            }
        }
    }
`;
const discountFragment = `
    fragment discountFields on Discount {
        enabled
        couponCode
        kind
        type
        label
        key
        level
        discountAmount
        discountValueType
        siteConditionSkuSet
        siteDiscountedProductSkus
        discountConditions {
          aggregator
          options {
            value
            isSimple
            conditionType
          }
        }
        conditionQuantity
    }
`;
exports.GET_ACTIVE_INTERNAL_DISCOUNT = `
    ${discountFragment}
    query GetActiveInternalDiscount {
        activeDiscount {
            discounts {
                ...discountFields
            }
            valueDiscounts {
                adjustableBaseMattress {
                    ...discountFields
                }
                bedFramesMattress {
                    ...discountFields
                }
                foundationMattress {
                    ...discountFields
                }
                pillowPair {
                    ...discountFields
                }
                nightstands {
                    ...discountFields
                }
            }
            includedDiscounts {
                solaireSheetBundleQueen {
                    ...discountFields
                }
                solaireSheetBundleKing {
                    ...discountFields
                }
                upperFlex {
                    sheetsSolaire
                    upperFlexMattressSkus
                    upperFlexSheetSkus
                }
            }
            surplusDiscounts {
                sheets {
                    ...discountFields
                }
                percaleSheets {
                    ...discountFields
                }
                linenSheets {
                    ...discountFields
                }
                percalePillowcase {
                    ...discountFields
                }
                linenPillowcase {
                    ...discountFields
                }
                pad {
                    ...discountFields
                }
            }
        }
    }
`;
/**
 * Gets the sitewide promotion data from the service promotions
 *
 * @export
 * @async
 * @param {string} url - service url
 * @param {{
 *  authToken?: string;
 *  variables?: {};
 *  captureException?: (error: any) => void;
 * }} options - service options
 * @returns {Promise<{} | null>}
 */
async function getPromotionServiceData(url, options = {}) {
    var _a;
    try {
        if (!url || typeof url !== 'string') {
            throw Error('Service URL must be provided.');
        }
        const headers = {
            'Content-Type': 'application/json'
        };
        if (options === null || options === void 0 ? void 0 : options.authToken) {
            headers['Authorization'] = `Bearer ${options.authToken}`;
        }
        const variables = (options === null || options === void 0 ? void 0 : options.variables) || {};
        const response = await fetch(url, {
            method: 'POST',
            headers,
            body: JSON.stringify({
                query: exports.GET_SITEWIDE_SALE,
                variables,
            })
        });
        const data = await response.json();
        const promotionData = (0, get_1.default)(data, 'data.getSitewideSale', null);
        if (!promotionData) {
            throw Error('Empty data returned from Service.');
        }
        return promotionData;
    }
    catch (error) {
        console.error('Error running service for fetching sitewide promotion data with error message:', error.message);
        (_a = options === null || options === void 0 ? void 0 : options.captureException) === null || _a === void 0 ? void 0 : _a.call(options, error);
        return null;
    }
}
/**
 * Gets the active internal discounts data from the service promotions
 *
 * @export
 * @async
 * @param {string} url - service url
 * @param {{
 *  authToken?: string;
 *  captureException?: (error: any) => void;
 * }} options - service options
 * @returns {Promise<{} | null>}
 */
async function getActiveDiscountData(url, options = {}) {
    var _a;
    try {
        if (!url || typeof url !== 'string') {
            throw Error('Service URL must be provided.');
        }
        const headers = {
            'Content-Type': 'application/json'
        };
        if (options === null || options === void 0 ? void 0 : options.authToken) {
            headers['Authorization'] = `Bearer ${options.authToken}`;
        }
        const response = await fetch(url, {
            method: 'POST',
            headers,
            body: JSON.stringify({
                query: exports.GET_ACTIVE_INTERNAL_DISCOUNT,
                variables: {},
            })
        });
        const data = await response.json();
        const activeDiscounts = (0, get_1.default)(data, 'data.activeDiscount', null);
        if (!activeDiscounts) {
            throw Error('Empty data returned from Service.');
        }
        return activeDiscounts;
    }
    catch (error) {
        console.error('Error running service for fetching active internal discounts data with error message:', error.message);
        (_a = options === null || options === void 0 ? void 0 : options.captureException) === null || _a === void 0 ? void 0 : _a.call(options, error);
        return null;
    }
}
//# sourceMappingURL=promotions.services.js.map